<template>
  <div class="about" :style="{minHeight:minheight + 'px'}">
    <div class="content-continer base-content">
      <div class="content">
        <img src="../assets/about1.png">
        <p>
          CRC（Clinical research coordinator）即临床协调员，是指经主要研究者授权在临床试验中协助研究者进行非医学判断的相关事务性工作，是临床试验的参与者、协调者。
          工作主要内容为根据GCP和研究方案要求，协助项目负责医生完成各项工作；协助受试者筛选、入组及随访工作；协助完成研究资料的收集、归档和管理工作。
        </p>
      </div>
      <div class="content">
          <img src="../assets/about2.png">
        <p>

          伦理委员会的联络：与伦理委员会联络，管理相关文件。
          知情同意：向患者说明试验内容，协助研究者获取知情同意。
          患者及其家属的教育、联络、咨询与商谈：知情同意签署前、试验过程中与试验结束后，作为与患者及其家属的联络人，负责疾病管理的教育、发生不良事件时的咨询等，涉及医疗与非医疗问题(如费用、赔偿等)。
          申办者(包括CRO)的联络与接待：与申办者进行各项事务的联络、协商；方案、CRF、知情同意等版本升级时的联络、协调与管理；应对监查(包括原始资料核查)、稽查；为申办者(包括CRO)准备、提供所要求的各种文件：如实验室正常值范围表、伦理委员会批件、研究者任务授权表等。

        </p>
      </div>
      <div class="content">
          <img src="../assets/about3.png">
          <p>
  
              1) 受试者的筛选与入组：根据方案安排筛选检查，与研究者共同探讨、判断入组试验的适合性。符合入组条件的病人按照讨论方案规定的程序人组，取得试验编码和随机编码(盲法试验)。<br>
              2) 试验进程的管理：按照方案规定的就诊时间窗协调受试者与研究医生的日程，安排就诊。<br>
              3) 病历等原始资料的管理。<br>
              4) CRF填写(与临床判断无关的，从原始资料的转录)，远程数据录入或EDC的数据录入(如适用)。<br>
              5) CRF与原始资料的核对，发现问题与研究医生商讨。<br>
              6) 临床检查：临床实验室检查标本的管理，特别是对于送往中心实验室的标本，进行离心等预处理，并确保标本运送前按规定保存;实施某些物理检查:如体温、血压、心电图检查等;临床检查结果管理：发现异常结果或异常变动，及时报告研究者;申办者提供的检查设备的保管、管理。<br>
              7) 不良事件：<br>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ①通过与受试者更多的接触，发现、报告(申办者、IRB及有关方面)、调查、追踪与记录不良事件。<br>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ②有医学、药学背景的CRC协助研究者判断不良事件的程度、因果关系。<br>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ③根据研究者的指示，处理不良事件。<br>
              8) 试验药与试验中所用药物的管理：<br>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;①服药指导、剩余药物的确认、回收，服药依从性的计算等。<br>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;②合并用药的记录、管理。<br>
              9) 试验 终止、中断、病例脱落时的应对。<br>
              文件管理：将试验实施机构应保存的文件归档。<br>
                                      
  
          </p>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'about',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        minheight: this.Common.minheight,
      }
    },
    beforeCreate() {
      document.querySelector('body').setAttribute('style', 'background-color:#F5F5F5;')
    },
    //销毁前清除
    beforeDestroy() {
      document.querySelector('body').removeAttribute('style')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .base-content {
    margin-top: 20px;
    margin-bottom: 80px;
    padding:0 80px;
    padding-bottom: 40px;
  }

  .content-continer {
    width: 1100px;
    color: #444;
    line-height: 28px;
   
  }
  p{
    font-size: 14px;
  }
  img{
   height: 35px;
   margin-bottom: 20px;
   margin-top: 40px;
  }
</style>


// WEBPACK FOOTER //
// src/components/about.vue